export class AttributeUtils {
  /**
   * @static
   * @param {string} value
   * @returns {boolean}
   */
  static convertToBoolean(value) {
    return value !== undefined && value !== null && value !== false && value !== 'false';
  }

  /**
   * @static
   * @param {string} value
   * @returns {string}
   */
  static convertToString(value) {
    if (typeof value === 'object' && value !== null) {
      return JSON.stringify(value);
    }

    return (value !== undefined && value !== null) ? value.toString() : '';
  }

  /**
   * @static
   * @param {string} value
   * @returns {*|*[]}
   */
  static convertToArray(value) {
    let parsedValue = value;

    if (typeof parsedValue === 'string') {
      try {
        parsedValue = JSON.parse(value);
      } catch (err) {
        return [];
      }
    }

    if (Array.isArray(parsedValue)) {
      return parsedValue;
    }

    return [];
  }

  /**
   * @static
   * @param {string} value
   * @returns {{}|*}
   */
  static convertToObject(value) {
    let parsedValue = value;

    if (typeof parsedValue === 'string') {
      try {
        parsedValue = JSON.parse(value);
      } catch (err) {
        return {};
      }
    }

    if ((typeof parsedValue === 'object') && !Array.isArray(parsedValue)) {
      return parsedValue;
    }

    return {};
  }
}
